import { Transform, Type } from 'class-transformer';
import {
	calendarDateTransformer,
	dateTransformer,
	integerTransformer,
} from 'src/lib/utilities/api/class-transformer-types';
import { UserAddressModel } from '../../utility/utility-models/address.model';
import { EnrollmentRequestStatusType } from '../students/student-enrollment-request-status.model';
import {
	StudentEnrollmentDataValuesModel,
	StudentEnrollmentDataValuesModel_ClassTransform_Type,
} from './salesforce.model';

export class ApprovalRequestModel {
	status: EnrollmentRequestStatusType;
	student_first_name: string;
	student_last_name: string;
	student_uid: number;
	salesforce_id: string;
	address: UserAddressModel;
	@Transform(calendarDateTransformer)
	birthdate: Date;
	phone: number;
	program_id: number;
	program_name: string;
	referral_source: string;
	opportunity_name: string;
	previous_school: string;
	currently_enrolled_prev: boolean;
	dropout_reason: string;
	@Transform(dateTransformer)
	dropout_date: Date;
	dropout_code: string;
	iep: boolean;
	504: boolean;
	iep_504_notes: string;
	district_id: string;
	state_id: string;
	@Transform(dateTransformer)
	submitted_on_timestamp: Date;
	@Transform(dateTransformer)
	approved_on_timestamp: Date;
}

export function ApprovalRequestModel_ClassTransform_Type() {
	return ApprovalRequestModel;
}

export class ApprovalDetailsModel {
	@Type(ApprovalDetailsApprovalsModel_ClassTransform_Type)
	approvals: ApprovalDetailsApprovalsModel[];
	submitted_by: string; // user name
	approved_by: string; // user name
	reason: string;
	suggested_approvers: [
		{
			approver_type: string;
			approvers: string[]; // user names
		},
	];
}

export function ApprovalDetailsModel_ClassTransform_Type() {
	return ApprovalDetailsModel;
}

export class ApprovalOptionsModel {
	dropout_code: {
		required: boolean;
	};
	approval_eligibility: {
		ineligible: boolean;
		reason: string;
		institutes: [
			{
				id: number;
				title: string;
			},
		];
	};
}

export class ApprovalDetailsApprovalsModel {
	approved_by: string;
	@Transform(dateTransformer)
	approved_on_timestamp: Date;
	@Transform(integerTransformer)
	approved_status: number; // 0: "Waiting Approval", 1: "Accepted", -1: "Rejected", -2: "Canceled"
	approver_type: string;
	reason: string;
}

export function ApprovalDetailsApprovalsModel_ClassTransform_Type() {
	return ApprovalDetailsApprovalsModel;
}

export class ApprovalRequestsTrackerResponseModel {
	count: number;
	skip: number;
	take: number;
	@Type(ApprovalRequestModel_ClassTransform_Type)
	results: ApprovalRequestModel[];
}

export class ApprovalModel {
	@Type(ApprovalRequestModel_ClassTransform_Type)
	approval_request: ApprovalRequestModel;
	@Type(ApprovalDetailsModel_ClassTransform_Type)
	approval_details: ApprovalDetailsModel;
	approval_options: ApprovalOptionsModel;
	@Type(StudentEnrollmentDataValuesModel_ClassTransform_Type)
	student_values?: StudentEnrollmentDataValuesModel;
}
